var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalePosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11300_1953)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9792 13.4799C19.0191 13.7447 18.9792 17.1489 18.9792 17.6974C18.9792 17.8676 18.8393 17.9811 18.6795 17.9811H1.31878C1.13898 18 0.999135 17.8676 0.999135 17.6974C0.999135 17.2246 0.979157 13.6312 1.01911 13.4799L2.7372 7.1253C2.75718 6.99291 2.89703 6.87943 3.03687 6.87943H4.15563C4.15563 6.57683 4.07572 6.14184 4.45529 6.14184H8.19114C8.57072 6.14184 8.49081 6.57683 8.49081 6.87943H13.1257V5.78251H10.3887C10.2089 5.78251 10.089 5.65012 10.089 5.49882V2.28369C10.089 2.11348 10.2289 2 10.3887 2H16.4819C16.6617 2 16.7816 2.13239 16.7816 2.28369V5.47991C16.7816 5.65012 16.6418 5.76359 16.4819 5.76359L13.7849 5.78251V6.87943H16.9614C17.1012 6.87943 17.2211 6.974 17.2611 7.10638L18.9792 13.4799ZM11.2477 8.65721V9.2435H12.1268V8.65721H11.2477ZM14.8038 11.1915V11.7778H15.6828V11.1915H14.8038ZM13.0258 11.1915V11.7778H13.9048V11.1915H13.0258ZM11.2477 11.1915V11.7778H12.1268V11.1915H11.2477ZM14.8038 9.92435V10.5106H15.6828V9.92435H14.8038ZM13.0258 9.92435V10.5106H13.9048V9.92435H13.0258ZM11.2477 9.92435V10.5106H12.1268V9.92435H11.2477ZM14.8038 8.65721V9.2435H15.6828V8.65721H14.8038ZM13.0258 8.65721V9.2435H13.9048V8.65721H13.0258ZM7.27217 14.766V15.3522H12.7461V14.766H7.27217ZM10.7283 5.19622H16.2022V2.58629H10.7283V5.19622ZM3.61623 9.92435H4.17561V7.46572H3.29658L1.71834 13.2908H18.2799L16.7017 7.46572H8.53077V9.92435H9.09015V10.5106H3.61623V9.92435ZM4.79492 9.92435H7.91146V6.72813H4.79492V9.92435ZM18.3798 13.8771H1.61845V17.4137H18.3798V13.8771Z",
    fill: "#4F5E71",
    stroke: "#4F5E71",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11300_1953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalePosIcon);
export default __webpack_public_path__ + "static/media/salePosIcon.d4117bf801d35a33d127fecf3abc89b3.svg";
export { ForwardRef as ReactComponent };